<template>
  <div>
    <div class="message-container" v-if="message.hasErrors">
              <chatbot-avatar class="mr-2"></chatbot-avatar>
              <span class="system-message" style="color: red;">
                {{ message.errorMessage }}
              </span>
            </div>
            <div class="message-container" v-if="message.role == 'assistant'">
              <chatbot-avatar class="mr-2"></chatbot-avatar>
            <assistant-message-content :message="message"></assistant-message-content>
            </div>
            <div class="message-container" v-if="message.role == 'thinking'">
              <chatbot-avatar class="mr-2"></chatbot-avatar>
              <span class="system-message">
                <img src="/img/loading-3dots.gif" style="height: 20px;">
              </span>
            </div>
            <div class="d-flex justify-end message-container" v-if="message.role == 'user'">

              <span class="user-message">
                {{ message.content }}
              </span>
              <chatbot-avatar :user="user" class="ml-2"></chatbot-avatar>
            </div>

  </div>
</template>

<script>
import ChatbotAvatar from './chatbot-avatar.vue';
import { mapGetters } from 'vuex'; 

import AssistantMessageContent from './assistant-message-content.vue';

export default {
  components: {  ChatbotAvatar, AssistantMessageContent },
  props:['message'],
data(){
    return {
        
    }
},
computed:{
  ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
      })
},
methods:{
 
}
}
</script>

<style>

</style>